import * as React from 'react';
import { Button, Typography } from '@mui/material';
import { AUTH_CONFIG } from '../../auth0-config';

const Maintenance: React.FC<{}> = () => {
  function handleLogout() {
    window.localStorage.clear();
    window.location.href = `https://${AUTH_CONFIG.domain}/v2/logout?returnTo=${AUTH_CONFIG.hostUrl}/logout`;
  }
  return (
    <div style={{ margin: '4em 0' }}>
      <Typography variant="h4" align="center">
        GLYNT.ai is currently undergoing maintenance
      </Typography>
      <Typography variant="subtitle1" align="center">
        We expect to be back in a couple of hours. Thanks for your patience.
      </Typography>
      <div
        style={{
          margin: '1em 0',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={() => window.location.reload()}
          variant="outlined"
          style={{ marginRight: 20 }}
        >
          Reload
        </Button>
        <Button onClick={handleLogout} variant="contained" color="primary">
          Logout
        </Button>
      </div>
    </div>
  );
};

export default Maintenance;
